export default {
    company_agency: "Loja",
    document: "DNI",
    no_company_agency_found: "Nenhuma loja encontrada",
    project_name: "Academia Alba",
}
